/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import Link from 'next/link';

const BrandItem = ({ brand }) => {
  const linkBaseUrl = '/brands/detail';

  return (
    <Link href={`${linkBaseUrl}/[id]`} as={`${linkBaseUrl}/${brand.id}`}>
      <div className="col-15 col-md-5 col-lg-3 mb-20">
        <a className="brand-card">
          <div className="mb-20">
            <Image
              src={`/image/brands/${brand.id}.jpg`}
              width="200"
              height="200"
              layout="responsive"
            />
          </div>
          <span className="brand-card-title">{brand.title}</span>
        </a>
      </div>
    </Link>
  );
};

BrandItem.propTypes = {
  brand: PropTypes.object,
};

export default BrandItem;
